import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useMessageModel } from '../../../hooks';
import styles from './style/index.less';
export var BlockInputting = function () {
    var View = useComponents().View;
    var messageModel = useMessageModel();
    return (React.createElement(View, { className: styles['inputting-container'] }, messageModel.isInputting && (React.createElement(View, { className: styles.inputting },
        "\u5BF9\u65B9\u6B63\u5728\u8F93\u5165",
        React.createElement(View, { className: styles['input-dot'] })))));
};
